<mat-spinner *ngIf="isLoading" class="loading-spinner"></mat-spinner>

<div class="container-available-internships"  *ngIf="!isLoading">

      <app-alert-message></app-alert-message>

    <div class="container-top">
        <header>
            <h1>{{'available-internships.available-internships' | translate }}</h1>
            <p>{{ 'available-internships.description' | translate }}</p>
        </header>

        <div class="pulsanti">
        <button class="createButton"
                (click)="openCreateAvailableInternshipDialog()"
                [disabled]="!isCreateAvailable"
            [matTooltip]="createTooltipReasonKey ? (createTooltipReasonKey | translate: createTooltipReasonParams) : ''"
                matTooltipPosition="below">
            <mat-icon>add</mat-icon>{{ 'available-internships.create' | translate }}
        </button>
        </div>
    </div>

    <div class="container-bottom">
        <div class="top">
            <div class="filtro-search">
                <label class="mat-label">{{ 'available-internships.global-search.label' | translate }}</label><br>
                <div class="mat-input-wrapper">
                    <input
                    type="text"
                    placeholder="{{ 'available-internships.global-search.placeholder' | translate }}"
                    class="mat-input"
                    [(ngModel)]="searchTerm"
                    (ngModelChange)="applyFilters()">
                </div>
            </div>

            <div class="filtro-status">
                <label class="mat-label">{{ 'available-internships.visibility.label' | translate }}</label><br>
                <div class="mat-input-wrapper">
                    <select
                    id="statusSelect"
                    class="mat-input"
                    [(ngModel)]="visibilityFilter"
                    (change)="applyFilters()">
                    <option value="">{{ 'available-internships.visibility.all' | translate }}</option>
                    <option value="true">{{ 'available-internships.visibility.enabled' | translate }}</option>
                    <option value="false">{{ 'available-internships.visibility.disabled' | translate }}</option>
                    </select>
                </div>
            </div>

            <div class="pulsanti">
                <button class="clearFilter" (click)="clearFilters()">
                    <mat-icon>filter_alt_off</mat-icon>{{ 'available-internships.clear' | translate }}
                </button>
            </div>
        </div>

        <div class="bottom">
            <section class="internship-list">
                <ng-container *ngIf="filteredData.length > 0; else noPositions">
                    <div *ngFor="let internship of filteredData"
                        class="internship-card"
                        [ngClass]="{ 'active': internship.visibility, 'expired': !internship.visibility }">

                        <!-- Stato visibilità sopra -->
                        <div class="internship-visibility">
                            <span>
                                {{
                                    internship.visibility
                                      ? ('available-internships.visibility.enabled' | translate)
                                      : ('available-internships.visibility.disabled' | translate)
                                }}
                            </span>
                        </div>

                        <h3 class="internship-header">
                            {{ internship.title }}
                        </h3>
                        <p>{{ internship.position }} | {{ internship.city.name }} ({{ internship.country.name }})</p>
                    
                        <div class="pulsanti">
                            <button class="view"(click)="viewAvailableInternshipDialog(internship)">
                                <mat-icon>list</mat-icon>
                            </button>

                            <!-- Se non è visibile → mostra icona "visibility" -->
                            <button class="view" *ngIf="!internship.visibility" (click)="toggleVisibility(internship)">
                                <mat-icon>visibility</mat-icon>
                            </button>

                            <!-- Se è visibile → mostra icona "visibility_off" -->
                            <button class="view" *ngIf="internship.visibility" (click)="toggleVisibility(internship)">
                                <mat-icon>visibility_off</mat-icon>
                            </button>

                            <button class="view"(click)="deleteAvailableInternshipDialog(internship.id)">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </div>
                    
                    </div>
                </ng-container>

                <ng-template #noPositions>
                    <p class="no-positions">
                        <mat-icon>info</mat-icon>
                        {{ 'available-internships.no-data' | translate }}
                    </p>
                </ng-template>

            </section>
        </div>

    </div>


</div>
